import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';

import StatusChip from './StatusChip';
import { fmtDate, fmtDateTime, fullName } from './adminFormat';

// Column definitions for the users table (PaginatedTable headCells).
// `id` doubles as the sortField sent to /admin/users.

const userCell = (val, row) => (
    <span style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
        {row.avatar ? (
            <Avatar src={row.avatar} style={{ width: 28, height: 28 }} />
        ) : (
            <AccountCircle style={{ width: 28, height: 28, color: '#B5C4C6' }} />
        )}
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{val}</span>
    </span>
);

const nameCell = (val, row) => fullName(row) || '—';
const statusCell = (val) => <StatusChip status={val} />;
const dateCell = (val) => fmtDate(val);
const dateTimeCell = (val) => fmtDateTime(val);

export const usersColumns = [
    { id: 'email', label: 'User', render: userCell },
    { id: 'name', label: 'Name', sortable: false, render: nameCell },
    { id: 'plan', label: 'Plan', render: (val) => val || '—' },
    { id: 'status', label: 'Status', render: statusCell },
    { id: 'lastLogin', label: 'Last login', render: dateTimeCell },
    { id: 'loginCount', label: 'Logins', numeric: true },
    { id: 'lessonCount', label: 'Lessons', numeric: true },
    { id: 'groupCount', label: 'Groups', numeric: true },
    { id: 'endDate', label: 'Plan ends', render: dateCell },
    { id: 'createdAt', label: 'Joined', render: dateCell },
];

export const subscriberColumns = [
    { id: 'email', label: 'User', render: userCell },
    { id: 'plan', label: 'Plan', render: (val) => val || '—' },
    { id: 'status', label: 'Status', render: statusCell },
    { id: 'startDate', label: 'Started', sortable: false, render: dateCell },
    { id: 'endDate', label: 'Ends / renews', render: dateCell },
    { id: 'canceledAt', label: 'Canceled at', sortable: false, render: dateCell },
    {
        id: 'trialStarted',
        label: 'Trial used',
        sortable: false,
        render: (val) => (val ? 'Yes' : 'No'),
    },
    {
        id: 'stripeCustomerSubscriptionId',
        label: 'Stripe subscription',
        sortable: false,
        render: (val) => (
            <span style={{ fontFamily: 'ui-monospace, Menlo, Consolas, monospace', fontSize: '0.78rem' }}>
                {val || '—'}
            </span>
        ),
    },
    { id: 'lastLogin', label: 'Last login', render: dateTimeCell },
];
